import React, { useState } from "react";
import { CallsInsightsContainer, PageWrapper } from "../../containers";

export const CallsInsights = () => {
  const [isLoading, setIsLoading] = useState(false);

  return <PageWrapper loading={isLoading} pageContainerChildren={<CallsInsightsContainer />} />;
};

export default CallsInsights;
